export function initMap() {
    var maps = document.querySelectorAll('.acf-map');

    for (var i = 0; i < maps.length; i++) {
        var mapContainer = maps[i];
        var count = mapContainer.getAttribute('data-count');
        var positions = [];
        for (var j = 1; j <= count; j++) {
            var lat = parseFloat(mapContainer.getAttribute('data-lat-' + j)) || 0;
            var lng = parseFloat(mapContainer.getAttribute('data-lng-' + j)) || 0;
            var address = mapContainer.getAttribute('data-address-' + j);

            positions.push({ lat, lng, address });
        }

        if (positions.length < 1) {
            continue;
        }

        var options = {
            center: { lat: positions[0].lat, lng: positions[0].lng },
            zoom: 15,
            mapId: "HEIMDAL_MAP",
        };

        var map = new google.maps.Map(mapContainer, options);
        var bounds = new google.maps.LatLngBounds();

        var marker, position, address;
        for (var j = 0; j < positions.length; j++) {
            position = {
                lat: positions[j].lat,
                lng: positions[j].lng
            };
            address = positions[j].address;
            marker = new google.maps.marker.AdvancedMarkerElement({
                position: position,
                map: map
            });
            google.maps.event.addListener(marker, 'click', function () {
                window.location.href = 'https://maps.google.com/?q=' + address;
            });
            if (positions.length > 1) {
                bounds.extend(position);
            }
        }
        if (positions.length > 1) {
            map.fitBounds(bounds);
        }
    }
}